import "./RotatingDots.css";
import "./RotatingDotsSmall.css";

export const RotatingDots = (props: { isSmall?: boolean }) => {
  const { isSmall } = props;
  const array = Array.from("x".repeat(8));

  return (
    <div className={isSmall ? "dots-small" : "dots"}>
      {array.map((_, index) => (
        <div key={index} className={isSmall ? "dot-small" : "dot"}></div>
      ))}
    </div>
  );
};
